import type { LabDataMock, LabOrderIncludedOrder, LabOrderIncludedResource } from '@type/lab.type'

export type PlacedLine = { key: string; label: string; orderId: string; lineStatus: string }

export function buildPlacedLines(data: LabDataMock, included: LabOrderIncludedResource[] | undefined): PlacedLine[] {
  if (data.type === 'lab_order') {
    const orderRefs = data.relationships.orders?.data ?? []
    const testNames = data.attributes.test_names ?? []
    // Include every named test even when there is no matching order relationship (e.g. creatable custom tests).
    const count = Math.max(orderRefs.length, testNames.length)

    return Array.from({ length: count }, (_, i) => {
      const ref = orderRefs[i]
      const inc = ref
        ? included?.find((x): x is LabOrderIncludedOrder => x.type === 'order' && x.id === ref.id)
        : undefined
      const label = testNames[i]?.trim() || `Test ${i + 1}`
      const lineStatus = String(inc?.meta?.status ?? data.attributes.status ?? 'pending')

      return {
        key: ref?.id ?? `test-name-${i}-${label}`,
        label,
        lineStatus,
        orderId: ref?.id ?? ''
      }
    })
  }

  const testRefId = data.relationships.orderable.data?.id
  const labTest = included?.find((x): x is LabOrderIncludedOrder => x.type === 'lab_test' && x.id === testRefId)
  return [
    {
      key: data.id,
      label: labTest?.attributes.name ?? 'Lab test',
      orderId: data.id,
      lineStatus: String(data.meta?.status ?? 'pending')
    }
  ]
}

export function orderTitleNumber(rawId: string) {
  const n = Number.parseInt(rawId, 10)
  if (!Number.isNaN(n)) return String(n).padStart(7, '0')
  return rawId
}
export function createLabResultAttachmentPayload(signed_id: string, test_name: string) {
  return {
    data: {
      type: 'lab_result',
      attributes: {
        attachment_signed_id: signed_id,
        test_name
      }
    }
  } as const
}
